import React from 'react';
import { connect } from 'react-redux';
import HoverActionHeader from '@/components/HoverActionHeader';
import { editCollection } from '../actions';

const CollectionFieldHeader = ({
  code,
  category,
  value,
  icon,
  canEdit,
  showEdit,
}) => (
  <HoverActionHeader
    icon={icon}
    canEdit={canEdit}
    showEdit={() => showEdit(category, code)}
    value={value}
    className="aridhia-collection-list-header"
  />
);

const mapDispatchToProps = {
  showEdit: editCollection,
};

export default connect(null, mapDispatchToProps)(CollectionFieldHeader);
